interface PublicGood {
  imgUrl: string;
  name: string;
  description: string;
  tags?: string[];
  to: string;
}

export const publicGoods: PublicGood[] = [
  {
    name: 'Lodestar',
    description: 'Ethereum Consensus client in Typescript',
    tags: ['node', 'ethereum'],
    imgUrl: 'https://imagedelivery.net/qdx9xDn6TxxInQGWsuRsVg/59dd386b-513a-4777-b763-9ee3f3325300/public',
    to: 'http://lodestar.chainsafe.io',
  },
  {
    name: 'Gossamer',
    description: 'The go-to alternative Polkadot client in Go',
    tags: ['node', 'polkadot'],
    imgUrl: 'https://imagedelivery.net/qdx9xDn6TxxInQGWsuRsVg/48406e51-bbdb-488e-5c80-924085ada700/public',
    to: 'https://chainsafe.github.io/gossamer/',
  },
  {
    name: 'Forest',
    description: 'A Filecoin implementation written in Rust',
    tags: ['node', 'filecoin'],
    imgUrl: 'https://imagedelivery.net/qdx9xDn6TxxInQGWsuRsVg/0d86c477-c268-447f-b033-14ffe6d50500/public',
    to: 'https://forest.chainsafe.io/',
  },
  {
    name: 'web3.js',
    description: 'JavaScript library for building on Ethereum',
    tags: ['API', 'ethereum'],
    imgUrl: 'https://imagedelivery.net/qdx9xDn6TxxInQGWsuRsVg/0c6183d7-4be9-4773-67a5-da3722e07e00/public',
    to: 'https://web3js.org',
  },
];
